import { useEffect, useState } from 'react'
import bestiaryData from '../../game/data/bestiary.json'
import { GlobalAudio } from '../../game/systems/AudioSystem'
import { useL10n } from '../hooks/useL10n'
import './Bestiary.css'

export default function Bestiary() {
  const [selectedId, setSelectedId] = useState(bestiaryData[0].id)
  const [imageLoading, setImageLoading] = useState(true)
  const { t, locale } = useL10n()
  const selectedEnemy = bestiaryData.find(e => e.id === selectedId) || bestiaryData[0]

  useEffect(() => {
    setImageLoading(true)
    
    const currentAudioKey = `lore_${selectedId}_${locale}`
    const suffix = locale === 'pt' ? '' : `_${locale}`
    const url = `/assets/audio/music/sfx/lore_${selectedId}${suffix}.mp3`

    // Load/register only the selected audio track
    GlobalAudio.loadSFX(currentAudioKey, url, { preload: false, html5: true })
    
    // Preload it to minimize delay when clicking play
    GlobalAudio.preloadSFX(currentAudioKey)

    return () => {
      GlobalAudio.stopSFX(currentAudioKey)
      GlobalAudio.unloadSFX(currentAudioKey)
    }
  }, [selectedId, locale])

  const handlePlayLore = () => {
    const currentAudioKey = `lore_${selectedId}_${locale}`
    GlobalAudio.playSFX(currentAudioKey, { duckTo: 0.3 })
  }

  return (
    <div className="bestiary">
      <div className="bestiary__sidebar">
        {bestiaryData.map(enemy => (
          <button
            key={enemy.id}
            className={`bestiary__item ${selectedId === enemy.id ? 'active' : ''}`}
            onClick={() => setSelectedId(enemy.id)}
          >
            {enemy.name}
          </button>
        ))}
      </div>
      
      <div className="bestiary__detail" key={selectedId}>
        <div className="bestiary__visual">
          {imageLoading && <div className="bestiary__loader">{t('ui.loading')}</div>}
          {'video' in selectedEnemy && selectedEnemy.video ? (
            <video 
              key={selectedEnemy.video}
              src={selectedEnemy.video} 
              autoPlay 
              loop 
              muted 
              playsInline
              className={`bestiary__sprite ${imageLoading ? 'loading' : 'loaded'}`}
              onLoadedData={() => setImageLoading(false)}
            />
          ) : (
            <img 
              key={selectedEnemy.image}
              src={selectedEnemy.image} 
              alt={selectedEnemy.name} 
              className={`bestiary__sprite ${imageLoading ? 'loading' : 'loaded'}`}
              onLoad={() => setImageLoading(false)}
            />
          )}
          <div className="bestiary__glow"></div>
        </div>
        
        <div className="bestiary__info">
          <div className="bestiary__header">
            <h3>{selectedEnemy.name}</h3>
            <button 
              className="bestiary__play-btn" 
              onClick={handlePlayLore}
              title={t('ui.listen')}
            >
              🔊 {t('ui.listen')}
            </button>
          </div>
          
          <div className="bestiary__lore-box">
            <p className="bestiary__lore">{t(`bestiary.${selectedEnemy.id}_lore`)}</p>
            <div className="bestiary__strategy">
              <strong>{t('ui.combat_tip')}</strong>
              <p>{t(`bestiary.${selectedEnemy.id}_strategy`)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
